<div *ngIf="!showEdit">
<h1 style="
font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
  Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
font-weight: 500;
color: #105481;
margin-bottom: 0.5rem;
font-size: 2.5rem;
font-weight: 500;
line-height: 1.2;
" id="inrefHeader">Ruter </h1>

<section class="check-section">
  <mat-checkbox [checked]= "dontShowExpChecked" (change)="dontShowExp($event)" class="checkbox-margin">Vis ikke eksplicitte ruter</mat-checkbox>
  <mat-checkbox [checked]= "showOnlyLegacyRoutesChecked" (change)="showOnlyLegacyRoutes($event)" class="checkbox-margin">Vis kun Legacy ruter</mat-checkbox>
</section>

<p-table #dt2 id="tableViewRoutestb_id" [rows]="rowsPerPage" (onRowSelect)="onRowSelect($event)" [paginator]="false"
  [rowHover]="true" [value]="tableViewRoutes" dataKey="id" selectionMode="single" [showFirstLastIcon]="false"
  stateStorage="session" [sortField]="sortField" [sortOrder]="sortOrder" [stateKey]="tableName"
  (sortFunction)="customSort($event)" [customSort]="true">
  <ng-template pTemplate="header">
    <tr>
      <th hidden="true" id="head1">id</th>
      <th style="width: 200px" pSortableColumn="infRef" id="head2">
        InfRef<p-sortIcon field="infRef"></p-sortIcon>
      </th>
      <th style="width: 200px" pSortableColumn="senderAuthority" id="head3">
        Myndighed(fra)<p-sortIcon field="senderAuthority"></p-sortIcon>
      </th>
      <th style="width: 200px" pSortableColumn="senderItSystem" id="head4">
        It-System(fra)<p-sortIcon field="senderItSystem"></p-sortIcon>
      </th>
      <th style="width: 200px" pSortableColumn="recipientAuthority" id="head5">
        Myndighed(til)<p-sortIcon field="recipientAuthority"></p-sortIcon>
      </th>
      <th style="width: 200px" pSortableColumn="recipientItSystem" id="head6">
        IT-system(til)<p-sortIcon field="recipientItSystem"></p-sortIcon>
      </th>
      <th style="width: 150px" pSortableColumn="isActive" id="head7">
        Status<p-sortIcon field="isActive"></p-sortIcon>
      </th>
      <th style="width:  150px" pSortableColumn="startDate" id="head8">
        StartDato<p-sortIcon field="startDate"></p-sortIcon>
      </th>
      <th style="width: 150px" pSortableColumn="endDate" id="head9">
        SlutDato<p-sortIcon field="endDate"></p-sortIcon>
      </th>
      

    </tr>
    <tr>
      <th id="head10">
        <input style="width: 100%" pInputText type="text" #textInput1
          (input)="inputChange(textInput1.value, 'infRef')" [value]="$any(dt2.filters['infRef'])?.value"
          class="p-column-filter" />
      </th>
      <th id="head11">
        <input style="width: 100%" pInputText type="text" #textInput2
          (input)="inputChange(textInput2.value, 'senderAuthority')" [value]="$any(dt2.filters['senderAuthority'])?.value"
          class="p-column-filter" />
      </th>
      <th id="head12">
        <input style="width: 100%" pInputText type="text" #textInput3
          (input)="inputChange(textInput3.value, 'senderItSystem')" [value]="$any(dt2.filters['senderItSystem'])?.value"
          class="p-column-filter" />
      </th>
      <th id="head13">
        <input style="width: 100%" pInputText type="text" #textInput4
          (input)="inputChange(textInput4.value, 'recipientAuthority')" [value]="$any(dt2.filters['recipientAuthority'])?.value"
          class="p-column-filter" />
      </th>
      <th id="head14">
        <input style="width: 100%" pInputText type="text" #textInput5
          (input)="inputChange(textInput5.value, 'recipientItSystem')" [value]="$any(dt2.filters['recipientItSystem'])?.value"
          class="p-column-filter" />
      </th>
      <th id="head15">
        <input style="width: 100%" pInputText type="text" #textInput6
          (input)="inputChange(textInput6.value, 'isActive')" [value]="$any(dt2.filters['isActive'])?.value"
          class="p-column-filter" />
      </th>
      <th id="head16">
        <input style="width: 100%" pInputText type="text" #textInput7
          (input)="inputChange(textInput7.value, 'startDate')" [value]="$any(dt2.filters['startDate'])?.value"
          class="p-column-filter" />
      </th>
      <th id="head17">
        <input style="width: 100%" pInputText type="text" #textInput8
          (input)="inputChange(textInput8.value, 'endDate')" [value]="$any(dt2.filters['endDate'])?.value"
          class="p-column-filter" />
      </th>

    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-prod>
    <tr [pSelectableRow]="prod">
      <td hidden="true">{{ prod.uuid }}</td>
      <td>{{ prod.infRef  }}</td>
      <td>{{ prod.senderAuthority  }}</td>
      <td>{{ prod.senderItSystem }}</td>
      <td>{{ prod.recipientAuthority }}</td>
      <td>{{ prod.recipientItSystem }}</td>
        <td> {{prod.isActive}}</td>
        <td> {{prod.startDate}}</td>
        <td> {{prod.endDate}}</td>
    </tr>

  </ng-template>
</p-table>
</div>
<div *ngIf="showEdit && !particularRow">Loading...</div>
<div *ngIf="showEdit && particularRow">
  <app-edit-route #editRouteComponent (submitClickedEvent)="editSubmit()" (cancelClickEvent)="cancelClick()" [particularRow]="originalParticularRow"></app-edit-route>
</div>

<p-confirmDialog
  [ngStyle]="{ backgroundColor: '$dialogHeaderBg: #ffffff;' }"
  [transitionOptions]="'400ms cubic-bezier(0.25, 0.8, 0.25, 1)'"
  header="Confirmation"
  acceptIcon=""
  rejectIcon=""
>
</p-confirmDialog>
<ngb-pagination #pagination *ngIf="showPagination && !showEdit" aria-label="pagination"
  class="d-flex justify-content-center" [collectionSize]="totalRecords" [(page)]="currentPage" [pageSize]="rowsPerPage"
  [maxSize]="5" [rotate]="true" size="lg" [boundaryLinks]="false" (pageChange)="onPageChange($event)">
</ngb-pagination>